import { medialUrl } from "../../../EndPoints";

import ManLadiesChildrenImage from "../../../assets/images/products/woven/mens-ladies-children.png";
import BoxerImage from "../../../assets/images/products/woven/Boxer.png";
import SportsWearImage from "../../../assets/images/products/woven/sports.png";
import LadiesTopImage from "../../../assets/images/products/woven/ladies_top.png";

import Cloth1Img from "../../../assets/images/products/woven/fabric-1.png";
import Cloth2Img from "../../../assets/images/products/woven/fabric-2.png";

import WovenVideo from "../../../assets/videos/woven.mp4";
import RedTriangleFill from "../../../assets/images/products/sweater/triangle-fill.png";
import RedTriangleStroke from "../../../assets/images/products/sweater/triangle-stroke.png";

import BgLineImg from "../../../assets/images/qa/qa-bg-line.png";

export const ApartmentIcon = `${medialUrl}/img/icons/Apartment.jpg`;
export const LineDecorator = BgLineImg;

export const RedTriangleFilledDecorator = RedTriangleFill;
export const RedTriangleNotFilledDecorator = RedTriangleStroke;

// Woven
// const ManLadiesChildrenImage = `${medialUrl}/img/Woven/Woven_Second_Section.png`;
// const BoxerImage = `${medialUrl}/img/Woven/Boxer.png`;
// const SportsWearImage = `${medialUrl}/img/Woven/sports.png`;
// const LadiesTopImage = `${medialUrl}/img/Woven/ladies_top.png`;

export const wovenArray = [
  {
    img: ManLadiesChildrenImage,
    text: "Men’s, Ladies & Children Wear",
  },
  {
    img: BoxerImage,
    text: "Boxer",
  },
  {
    img: SportsWearImage,
    text: "Sports Wear",
  },
  {
    img: LadiesTopImage,
    text: "Ladies Top",
  },
];

export const wovenStatCounter = [
  {
    number: 8,
    text: "Lines",
    icon: ApartmentIcon,
  },
  {
    number: "0.0",
    sign: "%",
    text: "Re-work & Re-check",
    icon: ApartmentIcon,
  },
];

// WovenForthSection
export const woven_video = WovenVideo;
export const WovenForthSectionContent = [
  {
    img: Cloth1Img,
    alt: "Cloth Type 1",
    text: "From tailored classics to contemporary masterpieces, each piece is meticulously crafted to perfection",
  },
  {
    img: Cloth2Img,
    alt: "Cloth Type 2",
    text: "Ensuring unparalleled quality and unmatched attention to detail. Explore our woven division and discover the epitome of sartorial excellence.",
  },
];
